export const tableData = {
  tHead: [
    {
      key: 'index',
      dataIndex: 'index',
      title: '序号',
      width: 50,
      slot: 'index',
    },
    {
      key: 'name',
      dataIndex: 'name',
      title: '博物馆名称',
    },
    {
      key: 'province',
      dataIndex: 'province',
      title: '省份',
    },
    {
      key: 'applylevel',
      dataIndex: 'applylevel',
      title: '申报等级',
    },
    {
      key: 'label',
      dataIndex: 'label',
      title: '评分情况',
    },
    {
      title: '评分',
      slot:'operatehz',
      fixed:'right'
    },
  ],
  tBody: [],
  tPage: {
    total: 0,
    page: 1,
    pageSize: 10
  },
};
export const tableData1 = {
  tHead: [
    {
      title: '序号',
      slot:'index',
    },
    {
      key: 'id',
      dataIndex: 'id',
      title: '评估指标',
    },
    {
      key: 'name',
      dataIndex: 'name',
      title: '指标内容',
      width:'200px'
    },
    {
      key: 'score1',
      dataIndex: 'score1',
      title: '2019年度',
      slot:'operate2019',
    },
    {
      key: 'score2',
      dataIndex: 'score2',
      title: '2020年度',
      slot:'operate2020',
    },
    {
      key: 'score3',
      dataIndex: 'score3',
      title: '2021年度',
      slot:'operate2021',
    },
  ],
  tBody: [],
  tPage: {
    total: 0,
    page: 1,
    pageSize: 10
  }
};
